import { z } from "zod";

import { banks } from "@/constants";

export const bank = z.enum([
  banks.caixa.value,
  banks.santander.value,
  banks.bradesco.value,
]);
